"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secsToString = exports.stringToSecs = void 0;
exports.stringToSecs = function (str) {
    var _a = str.split(':', 2), mins = _a[0], secs = _a[1];
    return parseInt(mins) * 60 + parseFloat(secs);
};
exports.secsToString = function (secs) {
    var mins = Math.floor(secs / 60);
    var minsStr = (mins < 10 ? '0' : '') + mins;
    var secsWithoutMins = (secs - mins * 60);
    var secsStr = (secsWithoutMins < 10)
        ? ('0' + secsWithoutMins.toFixed(1))
        : secsWithoutMins.toFixed(1);
    return minsStr + ":" + secsStr;
};
